'use es6';

import { createSelector } from 'reselect';
import { getActiveDomainName } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getAvailableDomains, getActiveStagingDomain, getHasMultiDomainScope, getPagePrimaryDomain } from 'ContentEditorUI/redux/selectors/portalDomainsSelectors';
export const getEmailPrimaryDomain = createSelector([getAvailableDomains, getPagePrimaryDomain], (availableDomains, primaryDomain = {}) => availableDomains.find(domain => domain.primary_email || domain.primaryEmail) || primaryDomain);
export const getEmailIsViolatingMultiDomainAccess = createSelector([getActiveDomainName, getEmailPrimaryDomain, getActiveStagingDomain, getHasMultiDomainScope], (contentModelDomain, emailPrimaryDomain, activeStagingDomain, hasMultiDomainScope) => {
  if (!hasMultiDomainScope) {
    if (activeStagingDomain) {
      return false;
    }
    if (contentModelDomain && emailPrimaryDomain) {
      return contentModelDomain !== emailPrimaryDomain.domain;
    }
  }
  return false;
});